import { useCallback } from 'react';
import { useVeloClient, GridAppLayout } from '@wix/velo-client';
import type { VeloCode } from '@wix/anyide-cli-file-structure';
import { useProjectModel } from '../../model.js';
import { loadProjectRootFiles } from '../../velo.js';

interface Options {
  branchId: string;
  revision: number;
  code: VeloCode;
}

export function useDeploySitePreview() {
  const { model } = useProjectModel();
  const { deploySitePreview } = useVeloClient();

  return useCallback(
    async ({ branchId, revision, code }: Options) => {
      const rootFiles = await loadProjectRootFiles(model.projectFolder);

      return deploySitePreview({
        deploymentData: {
          branchId,
          revision: String(revision),
          content: {
            ...code,
            files: code.files.concat(rootFiles),
            layout: GridAppLayout[code.layout],
          },
        },
      });
    },
    [deploySitePreview, model.projectFolder]
  );
}
